import { bindActionCreators } from 'redux';

export const LOADSCREEN_SHOW = 'NOTIFICATION/LOADSCREEN_SHOW';
export const LOADSCREEN_HIDE = 'NOTIFICATION/LOADSCREEN_HIDE';

const showLoadScreen = () => ({ type: LOADSCREEN_SHOW });

const hideLoadScreen = () => ({ type: LOADSCREEN_HIDE });

function containerActions(dispatch) {
  return bindActionCreators(
    {
      showLoadScreen,
      hideLoadScreen
    },
    dispatch
  );
}

export { containerActions, showLoadScreen, hideLoadScreen };



// WEBPACK FOOTER //
// ./src/components/LoadScreen/actions.js